import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=32e486ec&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=js&"
export * from "./Management.vue?vue&type=script&lang=js&"
import style0 from "./Management.vue?vue&type=style&index=0&id=32e486ec&prod&scoped=true&lang=css&"
import style1 from "./Management.vue?vue&type=style&index=1&id=32e486ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e486ec",
  null
  
)

export default component.exports